import { ICON } from './CommonConstants';

const { DONE, CLOSE } = ICON;

export const RESPONSE_TYPE = {
    CORRECT: 'correct',
    INCORRECT: 'incorrect',
    NO_RESPONSE: 'no-response',
};

const NR = 'nr';

export const CORRECTNESS_MARK = {
    [RESPONSE_TYPE.CORRECT]: DONE,
    [RESPONSE_TYPE.INCORRECT]: CLOSE,
    [RESPONSE_TYPE.NO_RESPONSE]: NR,
};
